/**
 * Resource Page Nav — IntersectionObserver-based active state + hash-driven FAQ opener
 *
 * @version 2026.06.02
 */

if (window.location.pathname.startsWith('/faqs')) {
	/**
	 * If the URL hash matches the id of a <details> element, open it and scroll to it.
	 * Also handles hash changes (e.g. clicking an anchor link to a specific question).
	 */
	function openDetailsFromHash() {
		const hash = window.location.hash.slice(1);
		if (!hash) return;
		const el = document.getElementById(hash);
		if (el instanceof HTMLDetailsElement) {
			el.open = true;
			el.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	document.addEventListener('DOMContentLoaded', openDetailsFromHash);
	window.addEventListener('hashchange', openDetailsFromHash);

	/**
	 * When a <details> element with an id is toggled, update the URL hash to reflect
	 * the open question without adding a browser history entry.
	 */
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('details[id]').forEach((el) => {
			el.addEventListener('toggle', () => {
				if (el.open) {
					history.replaceState(null, '', '#' + el.id);
				} else if (window.location.hash === '#' + el.id) {
					history.replaceState(
						null,
						'',
						window.location.pathname + window.location.search
					);
				}
			});
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const nav = document.querySelector('.resource-side-nav');
	if (!nav) return;

	const navItems = [...nav.querySelectorAll('li')];
	const links = [...nav.querySelectorAll('a[href^="#"]')];

	// Build ordered arrays of section elements and their corresponding nav items
	const sectionIds = [];
	const sectionNavMap = new Map(); // sectionId -> navItem li
	links.forEach((link, i) => {
		const id = link.getAttribute('href').slice(1);
		const section = document.getElementById(id);
		if (section && navItems[i]) {
			sectionIds.push(id);
			sectionNavMap.set(id, navItems[i]);
		}
	});

	if (sectionIds.length === 0) return;

	let visibleIds = [];

	const updateActive = () => {
		navItems.forEach((item) => item.classList.remove('is-active'));

		// Pick the first section (in nav order) that is currently visible
		const firstVisibleId = visibleIds.find((id) => sectionIds.includes(id));
		if (firstVisibleId) {
			const selectedElement = sectionNavMap.get(firstVisibleId);
			if (selectedElement) {
				selectedElement.classList.add('is-active');
				// selectedElement.scrollIntoView();
				selectedElement.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'center',
				});
			}
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					visibleIds.push(entry.target.id);
				} else {
					visibleIds = visibleIds.filter((id) => id !== entry.target.id);
				}
			});

			// Keep sorted by nav order so scrolling up highlights the correct item
			visibleIds.sort((a, b) => sectionIds.indexOf(a) - sectionIds.indexOf(b));
			updateActive();
		},
		{
			threshold: 0.1,
			rootMargin: '-100px',
		}
	);

	sectionIds.forEach((id) => {
		const el = document.getElementById(id);
		if (el) observer.observe(el);
	});
});
